import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';

/**
 * Redirect to service provider landing page if not a manager or paid service provider
 * @param next
 * @param state
 */
export const isManagerLike: CanActivateFn = async (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const user = inject(CurrentUserService);

  if (!user.isPaidAccount) {
    await router.navigate(['webapp', 'projects']); // landig page for free service provider
  }
  return true;
};
